/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import { CustomIcon } from '../../../components/SVGIcon';
import Localized from '../../../../shared/components/Localized';

import styles from '../../../styles';

const Wrapper = styled.div`
  padding: 1rem;
  background-color: ${styles.colors.linkWater};
  border-radius: .25rem;
  display: flex;


  @media (max-width: 767px) {
    padding: 1.25rem;
  }
`;

const Icon = styled.div`
  padding-right: 1rem;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
`;

const Heading = styled.div`
  line-height: 3rem;
  ${styles.fonts.headingMedium}
`;


const Header = ({ product }) => (
  <Wrapper>
    <Icon>
      <CustomIcon icon='custom53' bgColor='#EB706A' size='3rem' round />
    </Icon>
    <div>
      <Heading>
        <Localized modelName='product' modelKey={product} modelAttribute='label' />
      </Heading>
    </div>
  </Wrapper>
);

export default Header;
